import api, { request } from '../../../api';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { IAdminEventFormatsStore } from './store';

export interface IAdminEventFormatsActions extends IActionGroup {
  get: (
    clubId: number,
    eventId: number,
    force?: boolean
  ) => { adminEventFormats?: IAdminEventFormatsStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  get: async (state: IStore, clubId: number, eventId: number, force?: boolean) => {
    if (state.adminEventFormats && state.adminEventFormats[eventId] && !force) {
      return {
        adminEventFormats: state.adminEventFormats
      };
    }

    const response = await request.get(api.admin.eventFormats(clubId, eventId));

    if (response.error) {
      return {
        errors: { adminEventFormats: { msg: 'Error retrieving the Event Formats.' } }
      };
    }

    return {
      adminEventFormats: {
        ...state.adminEventFormats,
        [eventId]: response
      }
    };
  }
};

export default actions;
